import MuiPaper, { type PaperProps } from '@mui/material/Paper';
import { forwardRef } from 'react';

export const Paper = forwardRef<HTMLDivElement, PaperProps>(function Paper(
    { variant = 'outlined', ...props },
    ref,
) {
    return <MuiPaper ref={ref} variant={variant} {...props} />;
}) as typeof MuiPaper;

export { type PaperProps };
